<div class="dialog-container addmasterproduct">
    <div class="dialog-title-block">
        <h2>Add Category</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <form #f="ngForm" name="form" novalidate>  
        <div class="dialog-content-block p-3">
            <div class="d-flex gap-5 w-100 mt-4">
                <div class="w-50 d-flex flex-column">
                  <div class="form-group">
                    <div class="cabinet-dropdown stores">
                        <h6 class="text-start text-dark">Implant</h6>
                        <div class="w-100">
                            <span class="drop-down-btn header d-flex align-items-center justify-content-between" (click)="isImplantDropDown.set(!isImplantDropDown())">
                                <span>{{ selectedImplants.value }}</span>
                                <img src="../../../assets/images/dropdown.png" [class]="isImplantDropDown() ? 'drop-down-btn-icon--rotate' : ''" alt="arrow">
                            </span>
                            <ul class="dropdown-menu dropdown-content" [class]="isImplantDropDown() ? 'd-block' : ''">
                              <li *ngFor="let implant of implants" class="dropdown-item"  (click)="onImplantTypeChange(implant)">{{ implant.value }}</li>
                            </ul>
                        </div>
                    </div>
                   </div> 
                </div>
                <div class="w-50 d-flex flex-column">
                    <div class="form-group">
                        <h6 class="text-start text-dark">Name</h6>
                        <input type="text" name="product_code" [(ngModel)]="nameImplantTxt" value="" placeholder="Name">
                        <div class="form-error-msg"></div>
                    </div> 
                  </div>
            </div>
            <div class="d-flex gap-5 w-100 mt-4">
                <div class="w-50 d-flex flex-column">
                  <div class="form-group">
                      <h6 class="text-start text-dark">RK Number</h6>
                      <input type="text" name="product_code" [(ngModel)]="rkNumberTxt" value="" placeholder="RK Number">
                      <div class="form-error-msg"></div>
                  </div> 
                </div>
                <div class="w-50 d-flex flex-column">
                    <div class="form-group">
                        <h6 class="text-start text-dark">Title</h6>
                        <input type="text" name="product_code" [(ngModel)]="titleTxt" value="" placeholder="Title">
                        <div class="form-error-msg"></div>
                    </div> 
                  </div>
            </div>
            <div class="d-flex gap-5 w-100 mt-4">
                <div class="w-50 d-flex flex-column">
                  <div class="form-group">
                      <h6 class="text-start text-dark">Range</h6>
                      <input type="text" name="product_code" [(ngModel)]="rangeTxt" value="">
                      <div class="form-error-msg"></div>
                  </div> 
                </div>
                <div class="w-50 d-flex flex-column">
                    <div class="form-group">
                        <h6 class="text-start text-dark">Description</h6>
                        <input type="text" name="product_code" [(ngModel)]="descTxt" value="">
                        <div class="form-error-msg"></div>
                    </div> 
                  </div>
            </div>
        </div>
        <!-- <div class="form-error-msg">
            <p *ngIf="serverErrorMessage !== ''">{{ serverErrorMessage }}</p>
        </div> -->
        <div class="dialog-footer">
            <button type="button" (click)="onClose()">Cancel</button>
            <button class="primary-btn addproduct" type="submit" (click)="onAdd()">Add</button>
        </div>
    </form>
</div>
 